var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { "grid-list-xl": "", fluid: "" } },
    [
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "" } },
        [
          _c(
            "v-flex",
            { attrs: { xs8: "", "offset-xs2": "" } },
            [
              _c(
                "v-btn",
                { attrs: { small: "", color: "primary", to: "/fabrics" } },
                [_vm._v("Back to Fabrics")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.fabric
            ? _c(
                "v-flex",
                { attrs: { xs8: "", "offset-xs2": "" } },
                [
                  _c(
                    "v-card",
                    [
                      _c("v-card-title", [
                        _c("h4", [
                          _vm._v(
                            _vm._s(_vm.fabric.name) +
                              " - (" +
                              _vm._s(_vm.fabric.group.type) +
                              " - " +
                              _vm._s(_vm.fabric.group.name) +
                              ")"
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c(
                        "v-card-text",
                        [
                          _c(
                            "v-layout",
                            { attrs: { row: "", wrap: "" } },
                            [
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", md6: "" } },
                                [
                                  _c("v-select", {
                                    attrs: {
                                      items: _vm.fabricCategories,
                                      "item-text": "name",
                                      "item-value": "_id",
                                      label:
                                        "Pricing Categories (Note: Leave this blank for curtain fabrics)"
                                    },
                                    model: {
                                      value: _vm.fabric.category,
                                      callback: function($$v) {
                                        _vm.$set(_vm.fabric, "category", $$v)
                                      },
                                      expression: "fabric.category"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "Fabric Position (1 is highest)"
                                    },
                                    model: {
                                      value: _vm.fabric.position,
                                      callback: function($$v) {
                                        _vm.$set(_vm.fabric, "position", $$v)
                                      },
                                      expression: "fabric.position"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    attrs: { label: "Min Width" },
                                    model: {
                                      value: _vm.fabric.minWidth,
                                      callback: function($$v) {
                                        _vm.$set(_vm.fabric, "minWidth", $$v)
                                      },
                                      expression: "fabric.minWidth"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    attrs: { label: "Max Width" },
                                    model: {
                                      value: _vm.fabric.maxWidth,
                                      callback: function($$v) {
                                        _vm.$set(_vm.fabric, "maxWidth", $$v)
                                      },
                                      expression: "fabric.maxWidth"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    attrs: { label: "Max Drop" },
                                    model: {
                                      value: _vm.fabric.minDrop,
                                      callback: function($$v) {
                                        _vm.$set(_vm.fabric, "minDrop", $$v)
                                      },
                                      expression: "fabric.minDrop"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    attrs: { label: "Max Drop" },
                                    model: {
                                      value: _vm.fabric.maxDrop,
                                      callback: function($$v) {
                                        _vm.$set(_vm.fabric, "maxDrop", $$v)
                                      },
                                      expression: "fabric.maxDrop"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    attrs: { label: "From Price" },
                                    model: {
                                      value: _vm.fabric.priceFrom,
                                      callback: function($$v) {
                                        _vm.$set(_vm.fabric, "priceFrom", $$v)
                                      },
                                      expression: "fabric.priceFrom"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    attrs: { label: "TWC Name" },
                                    model: {
                                      value: _vm.fabric.twcName,
                                      callback: function($$v) {
                                        _vm.$set(_vm.fabric, "twcName", $$v)
                                      },
                                      expression: "fabric.twcName"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    attrs: { label: "Small Image" },
                                    model: {
                                      value: _vm.fabric.smallImage,
                                      callback: function($$v) {
                                        _vm.$set(_vm.fabric, "smallImage", $$v)
                                      },
                                      expression: "fabric.smallImage"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    attrs: { label: "Large Image" },
                                    model: {
                                      value: _vm.fabric.largeImage,
                                      callback: function($$v) {
                                        _vm.$set(_vm.fabric, "largeImage", $$v)
                                      },
                                      expression: "fabric.largeImage"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", md6: "" } },
                                [
                                  _c(
                                    "v-card",
                                    [
                                      _c("v-card-title", [
                                        _c("h4", [_vm._v("Curtain Categories")])
                                      ]),
                                      _vm._v(" "),
                                      _c("v-divider"),
                                      _vm._v(" "),
                                      _c(
                                        "v-card-text",
                                        [
                                          _c("v-select", {
                                            attrs: {
                                              items: _vm.fabricCategories,
                                              "item-text": "name",
                                              "item-value": "_id",
                                              label: "Non-SFold Centre Opening"
                                            },
                                            model: {
                                              value:
                                                _vm.fabric
                                                  .categoryNonSFoldCentre,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.fabric,
                                                  "categoryNonSFoldCentre",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "fabric.categoryNonSFoldCentre"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("v-select", {
                                            attrs: {
                                              items: _vm.fabricCategories,
                                              "item-text": "name",
                                              "item-value": "_id",
                                              label: "Non-Sfold One Way"
                                            },
                                            model: {
                                              value:
                                                _vm.fabric
                                                  .categoryNonSFoldOneway,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.fabric,
                                                  "categoryNonSFoldOneway",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "fabric.categoryNonSFoldOneway"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("v-select", {
                                            attrs: {
                                              items: _vm.fabricCategories,
                                              "item-text": "name",
                                              "item-value": "_id",
                                              label: "SFold Centre Opening"
                                            },
                                            model: {
                                              value:
                                                _vm.fabric.categorySFoldCentre,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.fabric,
                                                  "categorySFoldCentre",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "fabric.categorySFoldCentre"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("v-select", {
                                            attrs: {
                                              items: _vm.fabricCategories,
                                              "item-text": "name",
                                              "item-value": "_id",
                                              label: "SFold One Way"
                                            },
                                            model: {
                                              value:
                                                _vm.fabric.categorySFoldOneWay,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.fabric,
                                                  "categorySFoldOneWay",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "fabric.categorySFoldOneWay"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("v-divider"),
                                      _vm._v(" "),
                                      _c("v-card-title", [
                                        _c("h4", [
                                          _vm._v(
                                            "Cleaning and Energy Information"
                                          )
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c("v-divider"),
                                      _vm._v(" "),
                                      _c(
                                        "v-card-text",
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              label: "Cleaning Instructions"
                                            },
                                            model: {
                                              value: _vm.fabric.properties,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.fabric,
                                                  "properties",
                                                  $$v
                                                )
                                              },
                                              expression: "fabric.properties"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "v-btn-toggle",
                                            {
                                              model: {
                                                value: _vm.fabric.starRating,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.fabric,
                                                    "starRating",
                                                    $$v
                                                  )
                                                },
                                                expression: "fabric.starRating"
                                              }
                                            },
                                            [
                                              _c(
                                                "v-btn",
                                                { attrs: { flat: "" } },
                                                [
                                                  _vm._v(
                                                    "\n                      1"
                                                  ),
                                                  _c("v-icon", [_vm._v("star")])
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-btn",
                                                { attrs: { flat: "" } },
                                                [
                                                  _vm._v(
                                                    "\n                      2"
                                                  ),
                                                  _c("v-icon", [_vm._v("star")])
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-btn",
                                                { attrs: { flat: "" } },
                                                [
                                                  _vm._v(
                                                    "\n                      3"
                                                  ),
                                                  _c("v-icon", [_vm._v("star")])
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-btn",
                                                { attrs: { flat: "" } },
                                                [
                                                  _vm._v(
                                                    "\n                      4"
                                                  ),
                                                  _c("v-icon", [_vm._v("star")])
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-btn",
                                                { attrs: { flat: "" } },
                                                [
                                                  _vm._v(
                                                    "\n                      5"
                                                  ),
                                                  _c("v-icon", [_vm._v("star")])
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                large: "",
                                color: "primary",
                                loading: _vm.loading
                              },
                              on: {
                                click: function($event) {
                                  return _vm.updateFabric()
                                }
                              }
                            },
                            [_vm._v("Update")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-snackbar",
        {
          attrs: { dark: "", top: "", timeout: 3000 },
          model: {
            value: _vm.snackbar,
            callback: function($$v) {
              _vm.snackbar = $$v
            },
            expression: "snackbar"
          }
        },
        [
          _vm._v("\n    " + _vm._s(_vm.popupText) + "\n    "),
          _c(
            "v-btn",
            {
              attrs: { dark: "", flat: "" },
              on: {
                click: function($event) {
                  _vm.snackbar = false
                }
              }
            },
            [_vm._v("Close")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1baea680", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1baea680","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/fabrics/EditFabric.vue
// module id = null
// module chunks = 